'use client';
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useSettings } from '../hooks/use-settings.js';
/**
 * Provider for the theme
 * @example
 * ```ts
 * import { ThemeProvider } from "@cloud/shared/ui"
 *
 * <ThemeProvider>
 *   <App />
 * </ThemeProvider>
 * ```
 */
export function ThemeProvider({ children }) {
    const { settings } = useSettings();
    useEffect(() => {
        const bodyElement = document.body;
        // Update class names in the <body> tag
        Array.from(bodyElement.classList)
            .filter((className) => className.startsWith('theme-') || className.startsWith('radius-'))
            .forEach((className) => {
            bodyElement.classList.remove(className);
        });
        bodyElement.classList.add(`theme-${settings.theme}`);
        bodyElement.classList.add(`radius-${settings.radius ?? 0.5}`);
    }, [settings.theme, settings.radius]);
    return _jsx(_Fragment, { children: children });
}
